import { getCategoryHref } from '../../utils/common/category';
import { BOOK_IDEA_GENERATOR_CATEGORY } from '../../constants';

import { chipValues } from './shared';

const data = [
  {
    type: 'chips',
    properties: {
      isAdvanced: false,
      name: 'bookIdeaGeneratorType',
      analyticsName: 'book_idea_type',
      textLabel: 'Generate book ideas for...',
      hasErrorValidation: false,
      warningMessage: null,
      selectedCategory: BOOK_IDEA_GENERATOR_CATEGORY,
      required: false,
      flex: '100%',
      information: null,
      chipValues,
      defaultChipValue: {
        title: 'Book',
        value: getCategoryHref(BOOK_IDEA_GENERATOR_CATEGORY),
      },
    },
  },
  {
    type: 'input',
    properties: {
      name: 'bookIdeaGeneratorTopic',
      isAdvanced: false,
      flex: '100%',
      analyticsName: 'book_ideas_generator',
      placeholder: 'Try "humor about a modern family" or "science fiction and AI"',
      textLabel: 'Describe your book topic and genre',
      hasErrorValidation: true,
      warningMessage: null,
      information: null,
      selectedCategory: BOOK_IDEA_GENERATOR_CATEGORY,
      required: true,
      tooltipProps: null,
    },
  },
];

export default data;
